var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: 27,
    width: 8,
    height: 5,
    fill: "#00AB58"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 9,
    y: 29,
    width: 8,
    height: 3,
    fill: "#00AB58"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 18,
    y: 25,
    width: 8,
    height: 7,
    fill: "#00AB58"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 27,
    y: 14,
    width: 8,
    height: 18,
    fill: "#00AB58"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 17,
    width: 8,
    height: 15,
    fill: "#00AB58"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 9,
    width: 8,
    height: 23,
    fill: "#00AB58"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    width: 9,
    height: 32,
    fill: "#00AB58"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 64,
    y: 14,
    width: 8,
    height: 18,
    fill: "#00AB58"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 17,
    width: 8,
    height: 15,
    fill: "#00AB58"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 9,
    width: 8,
    height: 23,
    fill: "#00AB58"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    width: 9,
    height: 32,
    fill: "#00AB58"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 17,
    width: 8,
    height: 15,
    fill: "#00AB58"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 9,
    width: 8,
    height: 23,
    fill: "#00AB58"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    width: 9,
    height: 32,
    fill: "#00AB58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.a4168fc9439661c971e4209ab865b8a4.svg";
export { ForwardRef as ReactComponent };